import React from "react";
import "./nujobsCandidateProfile.scss";
import NuJobsCandidateProfileForm from "../nujobsCandidateProfileForm";
import { useParams } from "react-router-dom";


function NuJobsCandidateProfile() {
  const { value } = useParams();

  return (
    <div className="nujobscandidate-profile-container">
        {/* HEADER */}
        <div className="jobs-header">
          <div className="header-left">My Profile</div>
        </div>
        <NuJobsCandidateProfileForm rid ={value}/>
    </div>
  );
}

export default NuJobsCandidateProfile;
